import $ from 'jquery';

export const setupFormValidation = (): void => {
  window.setTimeout(() => {
    $('.fanchoice-submit-form form').validate({
      errorElement: 'div',
      onkeyup: false,
      onfocusout: false,
      onclick: false,
      errorPlacement(error, element) {
        error.prependTo(element.parents('.input-row'));
      },
    });

    $('.fanchoice-submit-form input').on('keyup blur', () => {
      const $form = $('.fanchoice-submit-form form');
      $form.find("button[type='submit']").prop('disabled', false);
    });

    $('.fanchoice-vote-form form').validate({
      errorElement: 'div',
      onkeyup: false,
      onfocusout: false,
      onclick: false,
      errorPlacement(error, element) {
        if (element.parents('.finalist-group').length > 0) {
          error.appendTo(element.parents('.finalist-group').find('.error-container'));
        } else {
          error.prependTo(element.parent());
        }
      },
      invalidHandler() {
        window.setTimeout(() => {
          $(".fanchoice-vote-form input[type='submit']").removeAttr('disabled');
        }, 500);
      },
    });

    $(".fanchoice-vote-form input[type='submit']").on('click keyup', function onVoteSubmit(this: HTMLElement) {
      $('.fanchoice-vote-form form').submit();
      $(this).attr('disabled', 'true');
    });

    $('.ticket-takeover-submission-form form').validate({
      errorElement: 'div',
      onkeyup: false,
      onfocusout: false,
      onclick: false,
      errorPlacement(error, element) {
        error.prependTo(element.parents('.input-row'));
      },
    });

    $('.ticket-takeover-submission-form input').on('keyup blur', () => {
      const $form = $('.ticket-takeover-submission-form form');
      $form.find("button[type='submit']").prop('disabled', false);
    });

    $('.ticket-takeover-voting-thank-you-form form').validate({
      errorElement: 'div',
      onkeyup: false,
      onfocusout: false,
      onclick: false,
      errorPlacement(error, element) {
        error.prependTo(element.parents('.input-row'));
      },
    });

    $('.ticket-takeover-voting-thank-you-form input').on('keyup blur', () => {
      const $form = $('.ticket-takeover-voting-thank-you-form form');
      $form.find("button[type='submit']").prop('disabled', false);
    });
  }, 500);
};
